import React from "react";

const SimpleColors = ({ qrOptions, handleColorChange, handleBgColorChange }) => {
    return (
        <>
            <div className="form-group">
                <label htmlFor="qr-color">Cor dos Pontos</label>
                <input type="color" id="qr-color" value={qrOptions.color || "#000000"} onChange={handleColorChange} />
                <input type="text" value={qrOptions.color || "#000000"} onChange={handleColorChange} />
            </div>
        </>
    );
};

export default SimpleColors;